import { FC, useState } from 'react';
import { useFm, useScreenType } from '@web3/base-hooks';
import { Block } from '@/components/block';
import { Title } from '@/components/title';
import cls from 'classnames';
import { scTrack } from '@web3/base-tracking';
import { Card } from './card';
import { useHomeStore } from '@/store/home';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';
import { Skeleton } from '@bfe/moly';

import styles from './index.module.scss';
import 'swiper/css';

export const Earn: FC = () => {
  const fm = useFm();
  const { isMobile } = useScreenType();
  const { activities, activitiesIsReady } = useHomeStore();
  const [mainSwiper, setMainSwiper] = useState<SwiperClass>();
  const [dict, setDict] = useState<'prev' | 'next'>('prev');
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setisBeginning] = useState(true);

  const list = activities || [];

  const onSwiperNext = () => {
    scTrack('Web3HomeClick', {
      page_name: 'home',
      area: 'earn',
      button_name: 'swiperNext',
    });
    setDict('next');
    if (!mainSwiper?.isEnd) {
      // 检查是否已经到达最后一页
      mainSwiper?.slideNext();
    } else {
      // console.log('已经到达最后一页');
    }
  };

  const onSwiperPrev = () => {
    scTrack('Web3HomeClick', {
      page_name: 'home',
      area: 'earn',
      button_name: 'swiperPrev',
    });
    setDict('prev');
    if (!mainSwiper?.isBeginning) {
      // 检查是否已经到达第一页
      mainSwiper?.slidePrev();
    } else {
      // console.log('已经到达第一页');
    }
  };

  if (activitiesIsReady && !list.length) {
    return null;
  }

  const swiperOptions = {
    slidesPerGroup: isMobile ? 1 : 4,
    spaceBetween: isMobile ? 20 : 24,
  };

  const displayPagination = isMobile ? list.length > 1 : list.length > 3;

  return (
    <Block clsName={styles.earnWrapper} noHeader>
      <Title>{fm('joinToEarn')}</Title>
      <div className={styles.earn}>
        {displayPagination && (
          <>
            <div
              className={cls('swper-custom-prev', {
                'swper-custom-disable': dict === 'prev' && isBeginning,
              })}
              onClick={onSwiperPrev}
            ></div>
            <div
              className={cls('swper-custom-next', {
                'swper-custom-disable': dict === 'next' && isEnd,
              })}
              onClick={onSwiperNext}
            ></div>
          </>
        )}
        <Swiper
          onSwiper={setMainSwiper}
          onSlideChange={(swiper) => {
            setIsEnd(swiper.isEnd);
            setisBeginning(swiper.isBeginning);
          }}
          slidesPerView="auto"
          slidesPerGroup={swiperOptions.slidesPerGroup}
          spaceBetween={swiperOptions.spaceBetween}
          className="mySwiper"
          style={{
            paddingTop: 10,
          }}
        >
          {activitiesIsReady &&
            list.map((item, index) => {
              return (
                <SwiperSlide key={index} className={styles.customSwiperSlider}>
                  <Card item={item} index={index} />
                </SwiperSlide>
              );
            })}
          {!activitiesIsReady && (
            <div className={styles.row}>
              {new Array(4).fill(1).map((item, index) => {
                return (
                  <>
                    <div className="pc">
                      <Skeleton.Bar
                        style={{
                          width: 332,
                          height: 313,
                          marginRight: 24,
                        }}
                      />
                    </div>
                    <div className="h5">
                      <Skeleton.Bar
                        style={{
                          width: 250,
                          height: 266,
                          marginRight: 20,
                        }}
                      />
                    </div>
                  </>
                );
              })}
            </div>
          )}
        </Swiper>
      </div>
    </Block>
  );
};

export default Earn;
